import {List} from 'immutable';

import {ClassroomModelV1} from 'src/resources/augmented/Classroom/ClassroomModel.v1';
import {Routes} from '../routes';
import type {StudentAssignment} from '../Assignments/StudentAssignment.types';
import type {ToDoSkills} from '../SkillPath/types';

interface Arguments {
  classrooms: List<ClassroomModelV1>;
  toDoAssignments: StudentAssignment[];
  toDoSkills: ToDoSkills;
}

/**
 * Gets the current user's default student homepage route.
 *
 * - IF the user is enrolled in at least one classroom
 *  - IF the user has To-Do assignments, their default route is `/home/assignments`
 *  - ELSE IF the user has To-Do skill paths, their default route is `/home/skill-path`
 *  - ELSE the user's default route is `/home/assignments`
 * - ELSE the user's default route is `/home/welcome`
 *
 * @param args - The arguments object.
 * @param args.classrooms - The list of classrooms the student is enrolled in.
 * @param args.toDoAssignments - The student's to-do assignments.
 * @param args.toDoSkills - The student's to-do skill paths.
 * @returns The default route string for the student homepage.
 */
export default function getUserDefaultRoute({classrooms, toDoAssignments, toDoSkills}: Arguments) {
  const hasClassrooms = classrooms.size > 0;
  const hasToDoAssignments = toDoAssignments.length > 0;
  const hasToDoSkills = toDoSkills.length > 0;

  let userDefaultRoute: Routes;

  if (hasClassrooms) {
    userDefaultRoute = hasToDoAssignments || !hasToDoSkills ? Routes.Assignments : Routes.SkillPath;
  } else {
    userDefaultRoute = Routes.Welcome;
  }

  return userDefaultRoute;
}
